function randomBytes (size) {
  const bytes = new Uint8Array(size);

  if (typeof globalThis.crypto === 'undefined' || typeof globalThis.crypto.getRandomValues !== 'function') {
    throw new Error('Web Crypto API is required to generate random bytes.');
  }

  globalThis.crypto.getRandomValues(bytes);

  return {
    toString (encoding) {
      if (encoding !== 'hex') {
        throw new Error(`Unsupported encoding: ${encoding}`);
      }

      return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    }
  };
}

module.exports = {
  randomBytes
};
